import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Tabs from '../components/erp/tabs/Tab'
import Order from '../components/erp/order/Order'
import ToShip from '../components/erp/toShip/ToShip';
import ToShipList from '../components/erp/toShipList/ToShipList';
import Inspection from '../components/erp/inspection/Inspection';
import OrderExcel from '../components/erp/order/OrderExcel';
import HandOrder from '../components/erp/order/HandOrder';
import DefectiveRegistration from '../components/erp/order/DefectiveRegistration';
import apiClient from '../components/ApiClient/ApiClient';

export default function BusinessManager () {
    const tabArray = ['訂單管理','檢收票','出貨交運單','出貨明細','訂單輸入','訂單手輸', '不良品登錄'];
    const [activeTab, setActiveTab] = useState(0);
    const [dataOrders, setOrdersData] = useState(null);
    const [dataToSHip, setToSHipData] = useState(null);
    const [dataToShipList, setToShipList] = useState(null);
    const navigate = useNavigate();

    const getTodayForApi = () => {
        const now = new Date();
        const y = now.getFullYear();
        const m = String(now.getMonth() + 1).padStart(2, '0');
        const d = String(now.getDate()).padStart(2, '0');
        return `${y}/${m}/${d}`;   // 對應後端的 "yyyy/MM/dd"
      };


    useEffect(() => {
      const token = sessionStorage.getItem('jwtData');
      if (!token) {
        navigate('/login');
      }
    }, [navigate]);

    useEffect(() => {
        const fetchData = async () => {
            let url;
            const today = getTodayForApi();  
            switch (activeTab) {
                case 0:
                    url = `/OrderManage/NoFilterGetMains?page=1`;
                    break;
                case 1:
                    url = `/Inspection/GetOrders`;
                    break;
                case 2:
                    // 出貨交運單：帶今天日期
                    url = `/ToShip/GetMains?page=1&month=${encodeURIComponent(today)}`;
                    break;
                case 3:
                    // 出貨明細：同樣帶今天日期
                    url = `/ToShip/GetMains?page=1&month=${encodeURIComponent(today)}`;
                    break;
                default:
                    setOrdersData(null);
                    setToSHipData(null);
                    setToShipList(null);
                    return;
            }
            try {
                const result = await apiClient.get(url);
                if (url === `/OrderManage/NoFilterGetMains?page=1`) {
                    setOrdersData(result.data);
                } else if (url === `/ToShip/GetMains?page=1&month=${encodeURIComponent(today)}`) {
                    setToSHipData(result.data);
                    setToShipList(result.data);
                } else if (url === `/Inspection/GetOrders`) {
                    setOrdersData(result.data);
                }
            } catch (error) {
                console.error(error);
            }
        };
        fetchData();
    }, [activeTab]);  

    const renderTabContent = (tabIndex) => {
        switch (tabIndex) {
            case 0:
                return <Order data={dataOrders}塞入資料/>;          // data={dataOrders}塞入資料
            case 1:
                return <Inspection />;  // data={dataOrders}
            case 2:
                return <ToShip data={dataToSHip}/>
            case 3:
                return <ToShipList data={dataToShipList}/>;
            case 4:
                return <OrderExcel/>;
            case 5:
                return <HandOrder/>;
            case 6:
                return <DefectiveRegistration/>;
            default:
                return null;
        }
    };

    return (
        <div>
            <Tabs tabsNames={tabArray} activeTab={activeTab} setActiveTab={setActiveTab}/>
            {renderTabContent(activeTab)}
        </div>
    );
}
